import { Toro } from '../common/enumerations';
import { ConnectedDevice } from './connected-device.model';
import { ImageAsset } from './image-asset.model';

export class ToroLocation {
    constructor(json: object = null) {
        if (json) {
            // Object.assign(this, json);
            // this.ConnectedDevice = null;

            this.AccountId = json['AccountId'];
            this.Sunrise = json['Sunrise'];
            this.Sunset = json['Sunset'];
            this.Id = json['Id'];
            this.Name = json['Name'];
            this.Description = json['Description'];
            this.Latitude = json['Latitude'];
            this.Longitude = json['Longitude'];
            this.UIZoomLevel = json['UIZoomLevel'];
            this.City = json['City'];
            this.State = json['State'];
            this.CountryName = json['CountryName'];
            this.UtcOffset = json['UtcOffset'];
            this.FirstDstChange = json['FirstDstChange'];
            this.LastDstChange = json['LastDstChange'];
            this.ImageAssetId = json['ImageAssetId'];
            this.ImageAsset = json['ImageAsset'];
            this.ConnectedDevices = json['ConnectedDevices'];
            this.ConnectedDevice = json['ConnectedDevice'] ? json['ConnectedDevice'] : null;//this.ConnectedDevices.find(x => x.LocationId === this.Id && x.DeviceTypeId === Toro.DeviceTypeId.Gateway);


        }
    }

    // Public Properties
    public AccountId: number;
    public Sunrise: string;
    public Sunset: string;
    public Id = 0;
    public Name: string;
    public Description: string;
    public Latitude: number;
    public Longitude: number;
    public UIZoomLevel: number;
    public City: string;
    public State: string;
    public CountryName: string;
    public UtcOffset: number;
    public FirstDstChange: string;
    public LastDstChange: string;
    public ImageAssetId: number;
    public ImageAsset: ImageAsset;
    public ConnectedDevice: ConnectedDevice;
    public ConnectedDevices: ConnectedDevice[];
}
